/** Fase 2 (W6, L11): textos do framework de importação do núcleo (BotaoModeloCsv e diálogo com prévia). */
export const importacaoPt = {
  importacao: {
    modelo: 'Baixar modelo',
    modeloTitulo: 'Baixar o modelo CSV com as colunas aceitas, inclusive os campos personalizados',
    importar: 'Importar CSV',
    texto: 'Cole o conteúdo do CSV ou escolha um arquivo. O modelo abre certo no Excel (ponto e vírgula); a linha de exemplo e a de dicas começam com # e são ignoradas.',
    chave: 'Quem já existe (mesmo {{colunas}}) é atualizado e o resto é criado. Célula vazia não apaga o que já está gravado.',
    colunas: 'Colunas aceitas',
    carregandoColunas: 'Carregando as colunas',
    obrigatoria: 'obrigatória',
    opcional: 'opcional',
    tipos: { texto: 'texto', numero: 'número', dinheiro: 'valor', booleano: 'sim ou não', data: 'data', lista: 'lista' },
    conteudo: 'Conteúdo do CSV',
    arquivo: 'Ou escolha um arquivo',
    escolherArquivo: 'Escolher arquivo',
    trocarArquivo: 'Trocar arquivo',
    simular: 'Simular',
    simularDeNovo: 'Simular de novo',
    gravar: 'Importar',
    naFila: 'Na fila, aguardando o processamento',
    simulando: 'Simulando, nada é gravado',
    importando: 'Importando',
    previa: 'Prévia: {{criados}} a criar, {{atualizados}} a atualizar, {{erros}} com erro. Nada foi gravado ainda.',
    previaDica: 'As linhas com erro ficam de fora. Corrija o arquivo e simule de novo, ou importe as outras.',
    resultado: 'Importação concluída: {{criados}} criados, {{atualizados}} atualizados, {{erros}} com erro.',
    ignoradas: 'Colunas que o importador não conhece e ficaram de fora: {{lista}}',
    linhasComErro: 'Linhas com erro',
    linha: 'Linha {{linha}}',
    maisErros_one: 'E mais {{count}} erro não listado.',
    maisErros_other: 'E mais {{count}} erros não listados.',
    grupos: { dados: 'Dados', endereco: 'Endereço principal', banco: 'Conta bancária', extra: 'Campos personalizados' },
    existentes_one: '{{count}} linha já tinha entrado e ficou como estava.',
    existentes_other: '{{count}} linhas já tinham entrado e ficaram como estavam.',
    contagens: {
      baixas: 'Pagamentos registrados como baixa: {{count}}',
      perdas: 'Perdas registradas: {{count}}',
      departamentos: 'Departamentos novos: {{count}}',
      funcoes: 'Funções novas (sem papel): {{count}}',
      vinculos: 'Vínculos novos noutra empresa: {{count}}',
      pulados: 'Linhas repetidas ignoradas: {{count}}',
    },
    linhasComAviso: 'Avisos por linha',
    maisAvisos_one: 'E mais {{count}} aviso não listado.',
    maisAvisos_other: 'E mais {{count}} avisos não listados.',
    sugestoes: 'Parecidos para conferir: {{lista}}',
  },
};

type Dic = typeof importacaoPt;

export const importacaoEn: Dic = {
  importacao: {
    modelo: 'Download template',
    modeloTitulo: 'Download the CSV template with the accepted columns, custom fields included',
    importar: 'Import CSV',
    texto: 'Paste the CSV content or choose a file. The template opens correctly in Excel (semicolon); the sample row and the hint row start with # and are ignored.',
    chave: 'Existing records (same {{colunas}}) are updated and the rest are created. An empty cell never erases what is already saved.',
    colunas: 'Accepted columns',
    carregandoColunas: 'Loading the columns',
    obrigatoria: 'required',
    opcional: 'optional',
    tipos: { texto: 'text', numero: 'number', dinheiro: 'amount', booleano: 'yes or no', data: 'date', lista: 'list' },
    conteudo: 'CSV content',
    arquivo: 'Or choose a file',
    escolherArquivo: 'Choose file',
    trocarArquivo: 'Change file',
    simular: 'Preview',
    simularDeNovo: 'Preview again',
    gravar: 'Import',
    naFila: 'Queued, waiting to be processed',
    simulando: 'Previewing, nothing is saved',
    importando: 'Importing',
    previa: 'Preview: {{criados}} to create, {{atualizados}} to update, {{erros}} with errors. Nothing was saved yet.',
    previaDica: 'Rows with errors are skipped. Fix the file and preview again, or import the others.',
    resultado: 'Import finished: {{criados}} created, {{atualizados}} updated, {{erros}} with errors.',
    ignoradas: 'Columns the importer does not know and were skipped: {{lista}}',
    linhasComErro: 'Rows with errors',
    linha: 'Row {{linha}}',
    maisErros_one: 'And {{count}} more error not listed.',
    maisErros_other: 'And {{count}} more errors not listed.',
    grupos: { dados: 'Details', endereco: 'Main address', banco: 'Bank account', extra: 'Custom fields' },
    existentes_one: '{{count}} row had already been imported and stayed as it was.',
    existentes_other: '{{count}} rows had already been imported and stayed as they were.',
    contagens: {
      baixas: 'Payments recorded as settlements: {{count}}',
      perdas: 'Write-offs recorded: {{count}}',
      departamentos: 'New departments: {{count}}',
      funcoes: 'New roles (no permission profile): {{count}}',
      vinculos: 'New employments at another company: {{count}}',
      pulados: 'Repeated rows skipped: {{count}}',
    },
    linhasComAviso: 'Notes per row',
    maisAvisos_one: 'And {{count}} more note not listed.',
    maisAvisos_other: 'And {{count}} more notes not listed.',
    sugestoes: 'Similar records to check: {{lista}}',
  },
};

export const importacaoEs: Dic = {
  importacao: {
    modelo: 'Descargar plantilla',
    modeloTitulo: 'Descargar la plantilla CSV con las columnas aceptadas, incluidos los campos personalizados',
    importar: 'Importar CSV',
    texto: 'Pega el contenido del CSV o elige un archivo. La plantilla se abre bien en Excel (punto y coma); la fila de ejemplo y la de pistas empiezan con # y se ignoran.',
    chave: 'Lo que ya existe (mismo {{colunas}}) se actualiza y el resto se crea. Una celda vacía nunca borra lo que ya está guardado.',
    colunas: 'Columnas aceptadas',
    carregandoColunas: 'Cargando las columnas',
    obrigatoria: 'obligatoria',
    opcional: 'opcional',
    tipos: { texto: 'texto', numero: 'número', dinheiro: 'monto', booleano: 'sí o no', data: 'fecha', lista: 'lista' },
    conteudo: 'Contenido del CSV',
    arquivo: 'O elige un archivo',
    escolherArquivo: 'Elegir archivo',
    trocarArquivo: 'Cambiar archivo',
    simular: 'Simular',
    simularDeNovo: 'Simular de nuevo',
    gravar: 'Importar',
    naFila: 'En cola, esperando el procesamiento',
    simulando: 'Simulando, no se guarda nada',
    importando: 'Importando',
    previa: 'Vista previa: {{criados}} por crear, {{atualizados}} por actualizar, {{erros}} con error. Todavía no se guardó nada.',
    previaDica: 'Las filas con error quedan fuera. Corrige el archivo y simula de nuevo, o importa las demás.',
    resultado: 'Importación terminada: {{criados}} creados, {{atualizados}} actualizados, {{erros}} con error.',
    ignoradas: 'Columnas que el importador no conoce y quedaron fuera: {{lista}}',
    linhasComErro: 'Filas con error',
    linha: 'Fila {{linha}}',
    maisErros_one: 'Y {{count}} error más no listado.',
    maisErros_other: 'Y {{count}} errores más no listados.',
    grupos: { dados: 'Datos', endereco: 'Dirección principal', banco: 'Cuenta bancaria', extra: 'Campos personalizados' },
    existentes_one: '{{count}} fila ya se había importado y quedó como estaba.',
    existentes_other: '{{count}} filas ya se habían importado y quedaron como estaban.',
    contagens: {
      baixas: 'Pagos registrados como liquidación: {{count}}',
      perdas: 'Pérdidas registradas: {{count}}',
      departamentos: 'Departamentos nuevos: {{count}}',
      funcoes: 'Funciones nuevas (sin perfil): {{count}}',
      vinculos: 'Vínculos nuevos en otra empresa: {{count}}',
      pulados: 'Filas repetidas ignoradas: {{count}}',
    },
    linhasComAviso: 'Avisos por fila',
    maisAvisos_one: 'Y {{count}} aviso más no listado.',
    maisAvisos_other: 'Y {{count}} avisos más no listados.',
    sugestoes: 'Parecidos para revisar: {{lista}}',

  },
};
